import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './httpService';
import { ConfigService } from './configService';
import { Driver } from '../components/verification-drivers-page/verification-drivers.model';

@Injectable()
export class DriversService {
    private baseUrl: string;

    constructor(private http: HttpService,
                private config: ConfigService) {
        this.baseUrl = this.config.get('apiUrl') + '/v1/user';
    }

    public getDrivers(qnum: number, qsuffix: string): Observable<Driver[]> {
        return this.http.get(`${this.baseUrl}/drivers/${qnum}/${qsuffix}`);
    }

    public addDriver(qnum: number, qsuffix: string, driver: Driver): Observable<Driver> {
        return this.http.post(`${this.baseUrl}/driver/${qnum}/${qsuffix}`, driver)
    }

    public updateDriver(driver: Driver): Observable<Driver> {
        return this.http.put(`${this.baseUrl}/driver`, driver)
    }

    public deleteDriver(id: number): Observable<Driver> {
        return this.http.delete(`${this.baseUrl}/drivers/${id}`)
    }
}